import { isImpersonationSession } from '../sessions'

/**
 * Formats the seconds left until a session expires for display in the dialog.
 * Impersonation sessions are short, so they count down in `mm:ss`; scoped-access
 * sessions run for hours and are shown as `x h x min`.
 */
export const formatRemainingTime = (
  secondsRemaining: number,
  type: string,
): string => {
  const seconds = Math.max(0, secondsRemaining)

  if (isImpersonationSession({ type })) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return `${hours} h ${minutes} min`
}

/**
 * Fraction (0–1) of the session's lifetime that is still left, used to size the
 * countdown progress bar. Falls back to `0` for sessions with a non-positive
 * total duration so the bar reads as fully elapsed.
 */
export const getRemainingFraction = (
  createdAt: string,
  expiresAt: string,
  secondsRemaining: number,
): number => {
  const totalSeconds =
    (new Date(expiresAt).getTime() - new Date(createdAt).getTime()) / 1000

  if (totalSeconds <= 0) return 0

  return Math.min(1, Math.max(0, secondsRemaining / totalSeconds))
}
